import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { ConfirmationService } from 'primeng/api';
import { BUILD_INFO } from '../../environments/build-info';

@Injectable({
  providedIn: 'root'
})
export class PromptUpdateService {

  constructor(
    private swUpdate: SwUpdate,
    private confirmationService: ConfirmationService
  ) {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      ).subscribe(() => {
        this.promptUser();
      });
    }
  }

  private promptUser(): void {
    this.confirmationService.confirm({
      message: `A new version of the application is available. Current build version: ${BUILD_INFO.version}. Load new version?`,
      header: 'Update Available',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Reload',
      rejectLabel: 'Later',
      accept: () => {
        // Activates the update and reloads the page
        this.swUpdate.activateUpdate().then(() => document.location.reload());
      }
    });
  }
}
